import axios from 'axios';
import { IdentityServerAuthRequest } from 'types/auth';

export const authenticateUser = async (request: IdentityServerAuthRequest): Promise<any> => {
  const authenticationUrl = `${process.env.REACT_APP_IDMS_AUTHENTICATION_URL}/Account/token`;

  return await axios.post(`${authenticationUrl}`, request);
};

export const refreshTokens = async (refreshToken: string): Promise<any> => {
  const authenticationUrl = `${process.env.REACT_APP_IDMS_AUTHENTICATION_URL}/Account/refreshtoken`;
  const secret = process.env.REACT_APP_IDMS_CLIENT_SC || '';
  const request = {
    RefreshToken: refreshToken,
    ClientId: 'dealerPortal',
    ClientSecret: secret
  };

  console.log('🔄');

  return await axios.post(`${authenticationUrl}`, request);
};
